import UrlParse from 'url-parse';
import UAParser from 'ua-parser-js';

export function WindowUtils(win = window) {
  this.redirect = (url) => win.location.assign(url);

  this.open = (url) => win.open(url, '_blank');

  this.getWindow = () => win;

  this.postMessageToParent = (msg, targetOrigin = '*') => {
    try {
      const stringified = JSON.stringify(msg);

      if (win.webkit) {
        win.webkit.messageHandlers.g2wUnified.postMessage(stringified);
      } else {
        win.parent.postMessage(stringified, targetOrigin);
      }
    } catch (error) {
      // ignore
    }
  };

  this.getWindowLocation = () => win.location;

  this.locationReplace = (url) => win.location.replace(url);

  this.getParsedUrl = (parser) => new UrlParse(win.location.href, parser);

  this.readQueryParameter = (param, route) => {
    if (route && (param in route.query)) {
      return route.query[param];
    }

    const parsedUrl = this.getParsedUrl(true);
    if (param in parsedUrl.query) {
      return parsedUrl.query[param];
    }

    return undefined;
  };

  this.readBooleanQueryParameter = (param, route) => {
    const value = this.readQueryParameter(param, route);
    return !!value || value === null || value === '';
  };

  this.getParsedUserAgent = () => {
    const parser = new UAParser();
    parser.setUA(win.navigator.userAgent);
    return parser.getResult();
  };

  this.addEventListener = (event, handler) => {
    win.addEventListener(event, handler);
  };

  this.removeEventListener = (event, handler) => {
    win.removeEventListener(event, handler);
  };

  this.getGlobal = (key) => win[key];

  this.loadScript = (src, options = {}) => new Promise((resolve) => {
    const script = win.document.createElement('script');
    script.src = src;
    script.async = (options.async !== false);
    script.onload = () => {
      resolve(this.getGlobal(options.resolveWithGlobal));
    };

    const parent = options.parent || win.document.body;
    parent.appendChild(script);
  });

  this.setInterval = (callback, duration) => win.setInterval(callback, duration);

  this.clearInterval = (intervalId) => win.clearInterval(intervalId);

  this.matchMedia = (mediaQueryString) => {
    if ('matchMedia' in win) {
      return win.matchMedia(mediaQueryString);
    }
    return null;
  };
}

const windowUtils = new WindowUtils(window);

export default windowUtils;
